<ng-template
  #overlay
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPanelClass]="['generic-zeva-popover-panel']"
  [cdkConnectedOverlayBackdropClass]="backdropClass"
  [cdkConnectedOverlayOrigin]="anchor"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="alignmentPositions"
  [cdkConnectedOverlayOffsetY]="offsetY"
  [cdkConnectedOverlayOffsetX]="offsetX"
  (backdropClick)="onBackdropClick()"
>
  <div
    class="zeva-popover popover-pos__{{ position }}"
    [ngClass]="panelClass"
    [ngStyle]="{
      'position': 'relative',
      'left': offsetX,
      'top': offsetY,
      'visibility': isOpen ? 'visible' : 'hidden'
    }"
    [@fade]="isOpen ? ('active-' + animateFrom) : null"
    [style]="panelStyle"
  >
    <div>
      @if (popoverContent) {
        <ng-container *ngTemplateOutlet="popoverContent.templateRef; context: { $implicit: context }" />
      }
      @else {
        <ng-content></ng-content>
      }
    </div>
  </div>
</ng-template>
